import React, { ReactElement } from 'react';
import { SelectDefinition } from 'models/select-definition';
import { TextBoxDefinition } from 'models/text-box-definition';
import { FilterTypeChooser } from './filter-type-chooser';

const SearchInput = ({ existedFilters }: iFilterRow): ReactElement | false => {
    const FilterTypeWithTextBox = (mobileSelectorValue: boolean) => {
        // eslint-disable-next-line react/prop-types
        const textbox = existedFilters.find((item) => {
            return item.type === 'TextBox';
        });

        return (
            <div>
                {textbox && (
                    <FilterTypeChooser
                        key={'filter_' + 11}
                        item={textbox}
                        mobileSelector={mobileSelectorValue}
                    />
                )}
            </div>
        );
    };
    return <div className="filter-panel__mobile">{FilterTypeWithTextBox(true)}</div>;
};

interface iFilterRow {
    existedFilters: (SelectDefinition | TextBoxDefinition)[];
    isActivePanel: boolean;
    isActive: boolean;
}

export { SearchInput };
